import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

import {ConfirmationService, SelectItem} from 'primeng/api';
import {Utils} from '@app/utils';
import {replace, startsWith } from 'lodash-es';

@Component({
  selector: 'app-route-select',
  templateUrl: './route-select.component.html',
  styleUrls: ['./route-select.component.css']
})
export class RouteSelectComponent implements OnInit, OnChanges {
  readonly ROUTE_SLIDE = '/image_slider';
  readonly ROUTE_WEBVIEW = '/web_view';

  @Input() route: string;
  @Output() routeChange: EventEmitter<string> = new EventEmitter<string>();

  items: SelectItem[] = [
    {label: 'ROUTE_COURSE', value: '/home/course'},
    {label: 'ROUTE_LEISURE', value: '/home/leisure'},
    // {label: 'ROUTE_COURSE_LIST', value: '/course_list'},
    // {label: 'ROUTE_LEISURE_LIST', value: '/leisure_list'},
    {label: 'ROUTE_HOTDEAL', value: '/hotdeals'},
    {label: 'ROUTE_TRANSPORTATION', value: '/leisure_list?category=3'},
    {label: 'ROUTE_REWARD', value: '/reward?tab=1'},
    {label: 'ROUTE_VOUCHER', value: '/reward?tab=2'},
    {label: 'ROUTE_SLIDE', value: this.ROUTE_SLIDE},
    {label: 'ROUTE_WEB', value: this.ROUTE_WEBVIEW}
  ];

  selectedRoute: string;

  value: string;

  imagesParam: { host?: string, path?: string, files?: string[] };
  webViewParam: { url?: string, prefix?: string };

  constructor(private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
  }

  addImage() {
    this.imagesParam.files.push('');
  }

  deleteImage(url: string) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete?',
      accept: () => {
        this.imagesParam.files = this.imagesParam.files.filter(v => v !== url);
      }
    });
  }

  onSelectRouteChanged() {
    if (this.selectedRoute !== this.ROUTE_SLIDE && this.selectedRoute !== this.ROUTE_WEBVIEW) {
      this.value = this.selectedRoute;
      this.routeChange.emit(this.value);
    }
  }

  applyImagesRoute() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to apply setting to ROUTE?',
      accept: () => {
        this.updateValue();
      }
    });
  }

  private updateValue() {
    if (this.selectedRoute === this.ROUTE_SLIDE) {
      this.value = `${this.ROUTE_SLIDE}?host=${this.imagesParam.host}&path=${this.imagesParam.path}&files=${this.imagesParam.files.join(',')}`;
    } else if (this.selectedRoute === this.ROUTE_WEBVIEW) {
      this.value = `${this.webViewParam.prefix}${this.webViewParam.url}`;
    } else {
      this.value = this.selectedRoute;
    }

    this.routeChange.emit(this.value);
  }

  getImageURL(imgfile: string) {
    return `${this.imagesParam.host}${this.imagesParam.path}${imgfile}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.route = changes['route'].currentValue;

    this.value = this.route;
    this.imagesParam = {};

    this.webViewParam = {
      'prefix': '/web_view?url='
    };

    if (startsWith(this.value, '/image_slider')) {
      this.selectedRoute = this.ROUTE_SLIDE;
      const urlParams = Utils.getUrlParams(this.value);
      this.imagesParam = {
        'host': urlParams['host'],
        'path': urlParams['path'],
        'files': urlParams['files'].split(','),
      };
    } else if (startsWith(this.value, '/web_view')) {
      this.selectedRoute = this.ROUTE_WEBVIEW;
      this.webViewParam = {
        'url': replace(this.value, '/web_view?url=', ''),
        'prefix': '/web_view?url='
      };
    } else {
      this.selectedRoute = this.route;
    }
  }
}
